import cn from 'classnames'
import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'
import { formatMarketCoverage } from 'partner360/features/topPartnersManagement/helpers/getMarketCoverage'
import { ICoverageImpact } from 'partner360/features/topPartnersManagement/models'

import styles from './CoverageImpactMessage.module.scss'

interface ICoverageImpactMessageProps {
  coverageImpact: ICoverageImpact
  translationKey: string
  tone?: 'increase' | 'decrease'
  extraReplaceParams?: { key: string; value: string }[]
}

export const CoverageImpactMessage: FC<ICoverageImpactMessageProps> = ({
  coverageImpact,
  translationKey,
  tone = 'decrease',
  extraReplaceParams = [],
}) => (
  <div className={cn(styles.root, tone === 'increase' ? styles.increase : styles.decrease)}>
    <Translation
      text={translationKey}
      replaceParams={[
        { key: '{coverage}', value: formatMarketCoverage(coverageImpact.next) },
        ...extraReplaceParams,
      ]}
    />
  </div>
)

CoverageImpactMessage.displayName = 'CoverageImpactMessage'
